import { render } from "./TranslationAttribution.vue?vue&type=template&id=63306897&scoped=true"
import script from "./TranslationAttribution.vue?vue&type=script&lang=js"
export * from "./TranslationAttribution.vue?vue&type=script&lang=js"

import "./TranslationAttribution.vue?vue&type=style&index=0&id=63306897&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63306897"]])

export default __exports__